import { CustomError } from 'cadenza/utils/custom-error';

export class OnDemandError extends CustomError {

  constructor () {
    super('OnDemand does not create new requests');
    /*
     * If this is not nullified, printing the error will display the stack where this object was created,
     * not the stack where the exception was logged, which is confusing.
     */
    this.stack = undefined;
  }

  override get name () { // NOSONAR javascript:S2376 The name of the error should not be overwritten, so not having a setter is ok here
    return 'OnDemandError';
  }

}
